import groq from 'groq';

import { RICH_TEXT } from '../common';
import {
  COALESCING_PRODUCT_VARIANT,
  PROMO_CODE_BLOCK_OR_PARENT,
} from '../product';
import { AMAZON_BUTTON } from '../product/amazonButton';
import { PRODUCT_FORMAT_FIELDS } from '../product/productFormat';
import { PRODUCT_MEDIA_FULL_LIST } from '../product/productMedia';
import { SEE_IT_IN_ACTION } from '../product/seeItInAction';

export const SKINCARE_FORMAT_PICKER = groq`
  _type,
  "productFormats": coalesce(product->productFormats->products[] {
    product-> {
      ${PRODUCT_FORMAT_FIELDS},
      "media": ${PRODUCT_MEDIA_FULL_LIST},
      "bulletPoints": bulletPointsV2[] { ${RICH_TEXT} },
      ${SEE_IT_IN_ACTION},
      disclaimer
    },
    ${COALESCING_PRODUCT_VARIANT}
  }, []),
  "promoCodes": ${PROMO_CODE_BLOCK_OR_PARENT},
  "isPromoCodeVisible": coalesce(isPromoCodeVisible, true),
  "isDiscountHidden": coalesce(isDiscountHidden, false),
  ctaType,
  ${AMAZON_BUTTON}
`;

export const SKINCARE_FORMAT_PICKER_BLOCK = groq`
  _type == 'timeline_skincareFormatPicker' => {
    ${SKINCARE_FORMAT_PICKER}
  }
`;
